import { gql } from '@apollo/client';

export const ALL_ORGANISATION_USERS_WITH_SESSIONS_ON_ACTIVITY = gql`
  query AllOrganisationUsersWithSessionsOnActivity($input: OrganisationUsersWithSessionOnActivity) {
    users: allOrganisationUsersWithSessionsOnActivity(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
